import React from 'react';
import List from '../List';
import { create } from 'react-test-renderer';
import { render, screen } from '@testing-library/react';
import userEvent from '@testing-library/user-event'

describe('Component List', () => {
  describe('Disability check', () => {
    const items = [{
      id: 1,
      imageUrl: 'https://test.abc',
      type: 'category',
      title: 'category title'
    }];

    it('should be disabled', async() => {
      const user = userEvent.setup();
      const onSelectionChanged = jest.fn();
      render(<List disabled={true} onSelectionChanged={onSelectionChanged} items={items} />);
      await user.click(screen.getByRole('listitem'));
      expect(onSelectionChanged).toHaveBeenCalledTimes(0);
    });
    it('should not be disabled', async() => {
      const user = userEvent.setup();
      const onSelectionChanged = jest.fn();
      render(<List disabled={false} onSelectionChanged={onSelectionChanged} items={items} />);
      await user.click(screen.getByRole('listitem'));
      expect(onSelectionChanged).toHaveBeenCalledTimes(1);
    });
  });

  it('renders default empty text', () => {
    render(<List />);
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'li'
      && content.toLowerCase().startsWith('no'))).toBeInTheDocument();
  });

  it('renders custom empty text', () => {
    const emptyText = 'test text';
    render(<List emptyText={"test text"}/>);
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'li'
      && content === emptyText)).toBeInTheDocument();
  });
  describe('snapshots', () => { 
    it('should match snapshot with no data', () => {
      const tree = create(<List></List>).toJSON();
      expect(tree).toMatchSnapshot();
    });

    it('should match snapshot with items', () => {
      const ITEM_DATA = [
        {
          id:0,
          type: 'asset',
          title: 'Asset title',
          locked: true,
          tag: 'Draft',
        }, {
          id:1,
          type: 'category',
          title: 'Category title',
        }
      ];
      const tree = create(<List items={ITEM_DATA}></List>).toJSON();
      expect(tree).toMatchSnapshot();
    });
   });
});